import { DEPOSIT_METHOD } from '.'

export const WALLET = {
  MAIN_WALLET: 'MAIN',
  AGENCY_WALLET: 'SUB'
}

export const DEFAULT_VALUE = {
  MIN: 50,
  MAX: 1000000
}

export const DEPOSIT_METHOD_VALIDATIONS = {
  [DEPOSIT_METHOD.QR_PAY]: { min: 50, max: 299000 },
  [DEPOSIT_METHOD.T_PAY]: { min: 50, max: 299000 }
}
